//AzeemKhan : 17-01-2023 : BT-97769 -  Breeze - Account Registration (eKYC) - Start
import { APP_INFO } from "../actionTypes";


const initialState = {
    appInfo: [],
    objAppinfo: {},
    termsAndCondition: '',
    aboutUs: '',
    exchangeTimings: {},
    brokerInformation: [],
    disclaimer: [],
    statesCities: [],
    chartAttributes: {},
    dynamicMenus: {},
    inAppIFrameData: { url: '', title: 'InApp' },
    dashMenu: false // BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix 
};
const appInfoReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case APP_INFO.GET_APPINFO_SUCCESS:
            return {
                ...state,
                appInfo: actions.payload.arrAppInfo,
                objAppinfo: actions.payload.objAppInfo
            };
        case APP_INFO.GET_TERMS_AND_CONDITION_SUCCESS:
            return {
                ...state,
                termsAndCondition: actions.payload
            };
        case APP_INFO.GET_TERMS_AND_CONDITION_FAILURE:
            return {
                ...state,
                termsAndCondition: actions.payload

            };
        case APP_INFO.GET_ABOUT_US_SUCCESS:
            return {
                ...state,
                aboutUs: actions.payload

            };
        case APP_INFO.GET_ABOUT_US_FAILURE:
            return {
                ...state,
                aboutUs: actions.payload

            };
        case APP_INFO.GET_DISCLAIMER_SUCCESS:
            return {
                ...state,
                disclaimer: actions.payload

            };
        case APP_INFO.GET_DISCLAIMER_FAILURE:
            return {
                ...state,
                disclaimer: actions.payload

            };
        case APP_INFO.GET_EXCHANGETIMINGS_SUCCESS:
            return {
                ...state,
                exchangeTimings: actions.payload

            };
        case APP_INFO.GET_EXCHANGETIMINGS_FAILURE:
            return {
                ...state,
                exchangeTimings: actions.payload

            };
        case APP_INFO.GET_BROKERINFORMATION_SUCCESS:
            return {
                ...state,
                brokerInformation: actions.payload

            };
        case APP_INFO.GET_BROKERINFORMATION_FAILURE:
            return {
                ...state,
                brokerInformation: actions.payload

            };
        case APP_INFO.GET_STATES_AND_CITIES_SUCCESS:
            return {
                ...state,
                statesCities: actions.payload
            };
        case APP_INFO.GET_STATES_AND_CITIES_FAILURE:
            return {
                ...state,
                statesCities: actions.payload
            };

        case APP_INFO.SET_CHART_ATTRIBUTES:

            return {
                ...state,
                chartAttributes: actions.payload
            };
        case APP_INFO.UPDATE_DYNAMIC_MENUS:
            return {
                ...state,
                dynamicMenus: actions.payload
            };
        //Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - Start
        case APP_INFO.UPDATE_INAPP_IFRAME: {
            return {
                ...state,
                inAppIFrameData: actions.payload
            };
        }
        //Maaz A : 07-09-2023 : BT-107437 - Breeze - Dashboard - Investments - End

        // BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix [start]
        case APP_INFO.SET_DASH_MENU: {
            return {
                ...state,
                dashMenu: actions.payload
            };
        }
        // BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix [end]

        default:
            return state;
    }

};
export default appInfoReducer;
//AzeemKhan : 17-01-2023 : BT-97769 -  Breeze - Account Registration (eKYC) - Ends